import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Divider, Group, Modal, Stack, Text } from '@mantine/core';

type Props = {
  onConfirm: () => void;
};

export const ExitWithoutUploadModal = NiceModal.create(({ onConfirm }: Props) => {
  const modal = useModal();

  const handleExit = () => {
    onConfirm();
    modal.remove();
  };

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.5, blur: 2 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Выйти без загрузки?"
      padding="lg"
      radius="md"
      styles={{
        title: { fontWeight: 700, fontSize: 'var(--mantine-font-size-lg)' },
        body: { paddingTop: 12 },
      }}
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Очередь не пуста. Все добавленные файлы будут сброшены.
        </Text>
        <Divider color="dark.4" />
        <Group justify="flex-end" gap="md">
          <Button variant="subtle" color="gray" onClick={() => modal.remove()}>
            Остаться
          </Button>
          <Button variant="outline" color="red" onClick={handleExit}>
            Выйти
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
});
